import { Box, Button, Stack, TextField, Typography } from '@mui/material'
import { FC, useCallback, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import api from '../../../../../Auth/api'
import { LoaderWrapper } from '../../../../../components/Wrappers/LoaderWrapper'
import { pushLog } from '../../../../Logger/store/logger'
import { getLicenseFx } from '../../store/getLicense'

export const UnlicensedBlock: FC = () => {
  const [loading, setLoading] = useState<boolean>(false)

  const formMethods = useForm()
  const { handleSubmit } = formMethods

  const onSubmit = useCallback((data: any) => {
    setLoading(true)
    api
      .post('license/activate', data)
      .then(({ data }) => {
        if (data?.data?.message) {
          pushLog({
            type: 'validation',
            message: data.data.message
          })
        }
        getLicenseFx()
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  return (
    <LoaderWrapper loading={loading}>
      <Stack spacing={1} mt={1} maxWidth={600}>
        <Box>
          <Stack direction={'row'} spacing={0.6}>
            <Typography>Приложение </Typography>
            <Typography sx={{ color: 'red' }}>не активировано</Typography>
          </Stack>
          <Typography>
            Пожалуйста для легального использоваия приложения внесите
            лицензионный ключ.
          </Typography>
        </Box>
        <Typography>Версия приложения: "Документооборот v1.0"</Typography>
        <FormProvider {...formMethods}>
          <form
            id="submitLicenseKeyForm"
            onSubmit={handleSubmit(onSubmit)}
          ></form>
          <Stack alignItems={'flex-end'} spacing={1} direction={'row'}>
            <TextField
              size="small"
              label="Лицензионный ключ"
              name="key"
              sx={{ width: '350px' }}
            />
            <Button
              variant="contained"
              type="submit"
              form="submitLicenseKeyForm"
            >
              Активировать
            </Button>
          </Stack>
        </FormProvider>
      </Stack>
    </LoaderWrapper>
  )
}
